export default __webpack_public_path__ + "static/O0171-f3d62d2d9b4febb241beb9953caa43b6.png";